import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { setBoothHistory } from '../../actions/booth_history';
import { setLoading, setMainLayers } from '../../actions/main';
import { setOpenSnack, setSnackMsg } from '../../actions/ui';
import { addText, checkifrectbooth, checkIfSelectable, getSqrt, px2unit, px2unitBig, resizeBooth, setObjectBG, unit2Px, unit2PxBig } from '../../utils/CanvasTool';

import {
  useLocation
} from "react-router-dom";

import BigNumber from "bignumber.js";
import { v4 as uuidv4 } from 'uuid';
import { addLog } from '../../actions/log';
import { convertRgbHex, PaperComponent } from '../../utils/Common';


const emails = ['username@gmail.com', 'user02@gmail.com'];

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function SetBoothModal(props) {
  
  let query = useQuery();
  // const [snackMsg, setSnackMsg] = useState('');
  // const [openSnack, setOpenSnack] = useState(false);
  const [activeObject, setActiveObject] = React.useState(null);
  const [priceCheck , setPriceCheck] = React.useState([]);
  const [premiumCheck , setPremiumCheck] = React.useState('');
  const [discountCheck, setDiscountCheck] = React.useState('');
  const [boothName , setBoothName] = React.useState('');
  const [boothWidth , setBoothWidth] = React.useState(0);
  const [boothHeight , setBoothHeight] = React.useState(0);
  const [boothShape , setBoothShape] = React.useState(''); // New: booth shape type
  const [boothArea , setBoothArea] = React.useState(''); // New: booth floor area
  const [boothLeft , setBoothLeft] = React.useState(0);
  const [boothTop , setBoothTop] = React.useState(0);
  const [boothAngle, setBoothAngle]  = React.useState(0);
  const [boothGroup , setBoothGroup] = React.useState('');
  const [boothCuratedGroup, setBoothCuratedGroup] = React.useState('');
  const [labelPosition , setLabelPosition] = React.useState('bottom-left');
  const [holdBooth, setHoldBooth] = React.useState(false);  
  const [privateNote, setPrivateNote] = React.useState('');
  const [publicNote, setPublicNote] = React.useState('');
  const [inviteCode, setInviteCode] = React.useState('');
  const [boothType, setBoothType] = React.useState('');

  
  var active_booth_file = props.main.active_booth_file
  var mainCanvas = props.main.mainCanvas
  const { onClose, onOk , open } = props;
  var groupOptions = props.main.groupOptions
  var curatedGroupOptions = props.main.curatedGroupOptions
  

  // const handleCloseSnack = ()=>{
  //   setOpenSnack(false);
  // }

  const onSet = ()=>{
    var convertRateX= 1
    if(mainCanvas.convertRateX) {
        var convertRateX= Math.abs(mainCanvas.convertRateX)
    }

    if(activeObject && activeObject.type=="activeSelection"){
      var objects = activeObject.getObjects()
      for(var i = 0; i < objects.length; i++ ){
        if(objects[i].class!="booth") continue;
        objects[i].set({      
          angle:boothAngle,
          // priceCheck: priceCheck,
          // premiumCheck: (premiumCheck),
          // discountCheck: discountCheck,
          boothGroup: boothGroup,
          boothCuratedGroup: boothCuratedGroup,
          labelPosition: labelPosition,
          boothType:boothType,
          invite_code:inviteCode,
          modified: true
        })
        var textObjects = objects[i].getObjects('text');
        for(var k = 0; k< textObjects.length; k++){
          objects[i].remove(textObjects[k])
        }
        addText(mainCanvas, objects[i], (objects[i].company?((objects[i].company+"").trim()+"\n"):"")+""+objects[i].booth_number)
        var premiumCheck = objects[i].get('premiumCheck')
        var priceCheck = objects[i].get('priceCheck')
        var discountCheck = objects[i].get('discountCheck')
        var exhibitors = objects[i].exhibitors
        var bgColor = "#dadada"
        {
          for(var k = 0; k < groupOptions.length; k++){
              if(groupOptions[k].KEY_ID == boothGroup){
                  var groupOption = groupOptions[k]
                  
                  if(objects[i].sold == '1'){
                    bgColor = convertRgbHex(groupOption[exhibitors?.[0].STATUS == '2'?'PENDING':'SOLD']);
                  }
                  else if((priceCheck && priceCheck.length > 0) || (premiumCheck && premiumCheck.length > 0) || (discountCheck && discountCheck.length > 0)){
                      bgColor = convertRgbHex(groupOption['AVAILABLE']);
                  }
              }
          }
        }

        setObjectBG(mainCanvas, objects[i], bgColor)
        objects[i].set({        
          deselectedColor: bgColor
        })
      }
    }
    else if(activeObject && activeObject.class=="booth"){
      // Capture original booth size before any mutation.
      // Prefer stored dwg_width/dwg_height (what the user last typed),
      // fall back to geometry-based size if they are not available.
      const oldWidthUnitsRaw = (activeObject.dwg_width !== undefined && activeObject.dwg_width !== null)
        ? activeObject.dwg_width
        : px2unit(activeObject.width, convertRateX, mainCanvas.mapUnit);
      const oldHeightUnitsRaw = (activeObject.dwg_height !== undefined && activeObject.dwg_height !== null)
        ? activeObject.dwg_height
        : px2unit(activeObject.height, convertRateX, mainCanvas.mapUnit);

      if(!boothName || boothName == ''){
        props.setOpenSnack(true);           
        props.setSnackMsg("Booth name can not be empty");
        return;
      }
      var trim_boothName = boothName.trim()
      var firstObjects = props.main.firstMapContent&&props.main.firstMapContent.objects?props.main.firstMapContent.objects:[]
      var objects = [...firstObjects]
      for(var i = 0; i < objects.length; i++){
        if(objects[i].KEY_ID != activeObject.KEY_ID){
          if(objects[i].booth_number == trim_boothName && trim_boothName&&objects[i].class=="booth"){ 
            props.setOpenSnack(true);           
            props.setSnackMsg("Booth Number exists already");
            return;
          }
        }
      }      
      objects = [...props.main.mapRemoveObjects] 
      for(var i = 0; i < objects.length; i++){
        if(objects[i].KEY_ID != activeObject.KEY_ID){
          if(checkIfSelectable(objects[i])&&objects[i].booth_number == trim_boothName && trim_boothName&&objects[i].class=="booth"){ 
            props.setOpenSnack(true);           
            props.setSnackMsg("Booth Number exists already");
            return;
          }
        }
      }
      objects = mainCanvas.getObjects();
      for(var i = 0; i < objects.length; i++){
        if(checkIfSelectable(objects[i])&& objects[i].KEY_ID != activeObject.KEY_ID&&objects[i].class=="booth"){
          if(objects[i].booth_number == trim_boothName && trim_boothName){ 
            props.setOpenSnack(true);           
            props.setSnackMsg("Booth Number exists already");
            return;
          }
        }
      }
      if(!boothWidth || boothWidth*1 ==0 || boothWidth == ''){
        props.setOpenSnack(true);           
        props.setSnackMsg("Booth width can not be empty");
        return;
      }
      if(!boothHeight || boothHeight*1 ==0 || boothHeight == ''){
        props.setOpenSnack(true);           
        props.setSnackMsg("Booth height can not be empty");
        return;
      }
      if(!boothLeft || boothLeft*1 ==0 || boothLeft == ''){
        props.setOpenSnack(true);           
        props.setSnackMsg("Position X can not be empty");
        return;
      }
      if(!boothTop || boothTop*1 ==0 || boothTop == ''){
        props.setOpenSnack(true);           
        props.setSnackMsg("Position Y can not be empty");
        return;
      }
      var newWidth = unit2Px(boothWidth, convertRateX, mainCanvas.mapUnit)
      var newHeight = unit2Px(boothHeight, convertRateX, mainCanvas.mapUnit)
      // if(mainCanvas.convertUnit == 'mm'){
      //   newWidth*=1000
      //   newHeight*=1000
      //   width/=1000
      //   height/=1000
      // }
      activeObject.set({
        booth_number: trim_boothName,
        labelPosition: labelPosition,
        boothGroup: boothGroup,
        boothCuratedGroup:boothCuratedGroup
      })
      mainCanvas.renderAll()
      var orgObject = activeObject.toDatalessObject()
      
      var mapOffsetX = unit2Px(mainCanvas.mapOffsetX?mainCanvas.mapOffsetX:0, convertRateX, mainCanvas.mapUnit)
      var mapOffsetY = unit2Px(mainCanvas.mapOffsetY?mainCanvas.mapOffsetY:0, convertRateX, mainCanvas.mapUnit)
      if(active_booth_file.version == 2){
        activeObject.set({
          dwg_left: boothLeft, 
          dwg_top: boothTop,
          left: unit2PxBig((new BigNumber(boothLeft)).minus((new BigNumber(mainCanvas.convertOffsetX)).dividedBy(mainCanvas.mapUnit == 'feet'?12:1)), convertRateX, mainCanvas.mapUnit).plus(50).plus(mapOffsetX).toNumber(),
          top: unit2PxBig(new BigNumber(mainCanvas.convertOffsetY).dividedBy(mainCanvas.mapUnit == 'feet'?12:1).minus(boothTop), convertRateX, mainCanvas.mapUnit).plus(50).plus(mapOffsetY).toNumber()
        })    
      }
      else{
        activeObject.set({
          left: unit2Px(boothLeft, convertRateX, mainCanvas.mapUnit) + 50 + mapOffsetX,
          top: unit2Px(boothTop, convertRateX, mainCanvas.mapUnit) + 50 + mapOffsetY
        })    
      }

      var resizedObject = activeObject
      var resizable = true;
      if(activeObject.class1 == "custom-booth" || !checkifrectbooth(activeObject, true)){
        resizable = false;
      }
      var objects = activeObject.getObjects('polygon');
      if(objects.length){
        var polygon = objects[0]
        if(polygon.points?.length < 4){
          resizable = false;
        }
      }
      if(resizable){
        resizedObject = resizeBooth(mainCanvas, activeObject, newWidth, newHeight)
      }
      else
      {
        var textObjects = resizedObject.getObjects('text');
        for(var k = 0; k< textObjects.length; k++){
          resizedObject.remove(textObjects[k])
        }
        addText(mainCanvas, resizedObject, (resizedObject.company&&(resizedObject.company+"").trim()!=""?((resizedObject.company+"").trim()+"\n"):"")+""+resizedObject.booth_number)
      }
      resizedObject.set({
        dwg_width: boothWidth, 
        dwg_height: boothHeight 
      })
      // activeObject.clipPath = new fabric.Rect({
      //   width: newWidth,
      //   height: newHeight,
      //   top: - (newHeight) / 2,
      //   left: - (newWidth) / 2
      // });

      // var boothGroup = activeObject.boothGroup;
      var premiumCheck = activeObject.get('premiumCheck')
      var priceCheck = activeObject.get('priceCheck')
      var discountCheck = activeObject.get('discountCheck')
      var exhibitors = activeObject.exhibitors
      var bgColor = "#dadada"
      {
        for(var k = 0; k < groupOptions.length; k++){
            if(groupOptions[k].KEY_ID == boothGroup){
                var groupOption = groupOptions[k]
                if(holdBooth){
                  bgColor = convertRgbHex(groupOption['RESERVED']);
                }
                else if(resizedObject.sold == '1'){
                  bgColor = convertRgbHex(groupOption[exhibitors?.[0].STATUS == '2'?'PENDING':'SOLD']);
                }
                else if((priceCheck && priceCheck.length > 0) || (premiumCheck && premiumCheck.length > 0) || (discountCheck && discountCheck.length > 0)){
                    bgColor = convertRgbHex(groupOption['AVAILABLE']);
                }
            }
        }
      }

      setObjectBG(mainCanvas, resizedObject, bgColor)
      resizedObject.set({        
        angle:boothAngle,
        modified: true,
        deselectedColor: bgColor,
        holdBooth: holdBooth?'1':false,
        privateNote:privateNote,
        publicNote:publicNote,
        boothType:boothType,
        invite_code:inviteCode
      })

      // Audit log: booth size change (compare original vs new size in map units)
      const oldWidthUnits = Number(oldWidthUnitsRaw)
      const oldHeightUnits = Number(oldHeightUnitsRaw)
      const newWidthUnits = Number(boothWidth)
      const newHeightUnits = Number(boothHeight)
      const hasValidOldSize = !Number.isNaN(oldWidthUnits) && !Number.isNaN(oldHeightUnits)
      const hasValidNewSize = !Number.isNaN(newWidthUnits) && !Number.isNaN(newHeightUnits)
      const sizeChanged = hasValidOldSize && hasValidNewSize &&
        (oldWidthUnits !== newWidthUnits || oldHeightUnits !== newHeightUnits)

      if (sizeChanged) {
        const unitLabel = mainCanvas.mapUnit || ''
        const formatSize = (w, h) => `${w}x${h}${unitLabel ? ' ' + unitLabel : ''}`
        const oldSizeLabel = formatSize(oldWidthUnitsRaw, oldHeightUnitsRaw)
        const newSizeLabel = formatSize(boothWidth, boothHeight)
        props.addLog({
          BOOTH_KEY: resizedObject.KEY_ID,
          KEY_ID: uuidv4(),
          action: 'resize',
          date: new Date().toLocaleString(),
          description: `Assigned Booth ${resizedObject.booth_number} updated from ${oldSizeLabel} to ${newSizeLabel}`,
          user: (props.main.authInfo?.user_name ? props.main.authInfo?.user_name : "Admin")
        })
      }

      props.setBoothHistory({ content: (props.main.mainCanvas.toDatalessObject()), action:{type:'updated', orgObjects:[orgObject], target:resizedObject}})
    }
    mainCanvas.renderAll()
    onOk(activeObject);
  }
  

  
  useEffect(() => {
    var mainCanvas = props.main.mainCanvas
    if(open && mainCanvas){      
      var activeObject = mainCanvas.getActiveObject();

      if(activeObject.type == "group" && (activeObject.class=="booth" || activeObject.class=="booth-group")){
        var convertRateX= 1
        if(mainCanvas.convertRateX) {
            var convertRateX= Math.abs(mainCanvas.convertRateX)
        }

        setBoothName(activeObject.booth_number)
        var decimal = 1;
        // if((activeObject.width)/feetUnitSize < 1) decimal = 2
        //1326.3833333333334, 12.685166666666667
        var mapOffsetX = (mainCanvas.mapOffsetX?mainCanvas.mapOffsetX:0)
        var mapOffsetY = (mainCanvas.mapOffsetY?mainCanvas.mapOffsetY:0)
        if(active_booth_file.version == '2'){
          var leftTxt = px2unitBig((new BigNumber(activeObject.left)).minus(50), convertRateX, mainCanvas.mapUnit).plus((new BigNumber(mainCanvas.convertOffsetX)).dividedBy(mainCanvas.mapUnit == 'feet'?12:1)).minus(mapOffsetX)
          var topTxt = (new BigNumber(mainCanvas.convertOffsetY)).dividedBy(mainCanvas.mapUnit == 'feet'?12:1).minus(px2unitBig((new BigNumber(activeObject.top)).minus(50),convertRateX, mainCanvas.mapUnit).minus(mapOffsetY))
          // setBoothWidth(activeObject.dwg_width)
          // setBoothHeight(activeObject.dwg_height)
          let width = px2unit(activeObject.width, convertRateX, mainCanvas.mapUnit)
          let height = px2unit(activeObject.height, convertRateX, mainCanvas.mapUnit)
          // if(mainCanvas.convertUnit == 'mm'){
          //   leftTxt/=1000
          //   topTxt/=1000
          //   width/=1000
          //   height/=1000
          // }
          setBoothWidth(width.toFixed(decimal).replace(/\.0$/, ""))
          setBoothHeight(height.toFixed(decimal).replace(/\.0$/, ""))
          setBoothLeft(leftTxt.toFixed(12))
          setBoothTop(topTxt.toFixed(12))
        }
        else{
          let width = px2unit(activeObject.width, convertRateX, mainCanvas.mapUnit)
          let height = px2unit(activeObject.height, convertRateX, mainCanvas.mapUnit)
          var leftTxt = (px2unit(activeObject.left-50, convertRateX, mainCanvas.mapUnit)-mapOffsetX)
          var topTxt = (px2unit(activeObject.top-50, convertRateX, mainCanvas.mapUnit)-mapOffsetY)
          // if(mainCanvas.convertUnit == 'mm'){
          //   leftTxt/=1000
          //   topTxt/=1000
          //   width/=1000
          //   height/=1000
          // }
          setBoothWidth(width.toFixed(decimal).replace(/\.0$/, ""))
          setBoothHeight(height.toFixed(decimal).replace(/\.0$/, ""))
          setBoothLeft(leftTxt.toFixed(6))
          setBoothTop(topTxt.toFixed(6))
        }
        setBoothGroup(activeObject.boothGroup?activeObject.boothGroup:"")
        setBoothCuratedGroup(activeObject.boothCuratedGroup?activeObject.boothCuratedGroup:"")
        setLabelPosition(activeObject.labelPosition?activeObject.labelPosition:"bottom-left")
        
        setBoothAngle(activeObject.angle)
        setHoldBooth(activeObject.holdBooth)
        setPrivateNote(activeObject.privateNote?activeObject.privateNote:"")
        setPublicNote(activeObject.publicNote?activeObject.publicNote:"")
        setInviteCode(activeObject.invite_code?activeObject.invite_code:'')
        setBoothType(activeObject.boothType?activeObject.boothType:'')

        // Determine booth shape type
        const isCustom = activeObject.class1 === 'custom-booth' || !checkifrectbooth(activeObject, true);
        setBoothShape(isCustom ? 'Custom' : 'Standard');

        // Calculate and set booth area
        const area = getSqrt(activeObject, props);
        const unitLabel = mainCanvas.mapUnit === 'feet' ? 'sqft' : 'sqm';
        setBoothArea(`${area.toFixed(2)} ${unitLabel}`);

        var tmp1 = activeObject.get('premiumCheck')
        if(tmp1){
          setPremiumCheck(tmp1)
        }
        else{
          setPremiumCheck([])
        }
        var tmp2 = activeObject.get('priceCheck')
        if(tmp2){
          setPriceCheck(tmp2)
        }
        else{
          setPriceCheck([])
        }
        var tmp3 = activeObject.get('discountCheck')
        if(tmp3){
          setDiscountCheck(tmp3)
        }
        else{
          setDiscountCheck([])
        }
      }
      else if(activeObject.type == "activeSelection"){
        var objects = activeObject.getObjects()
        var arr1 = [];
        for(var i = 0; i < objects.length; i++ ){
          if(objects[i].boothGroup){
            arr1.push(objects[i].boothGroup)
          }
        }
        var mf = 1;
        var m = 0;
        var maxGroup
        for (var i=0; i<arr1.length; i++)
        {
                for (var j=i; j<arr1.length; j++)
                {
                        if (arr1[i] == arr1[j])
                        m++;
                        if (mf<m)
                        {
                          mf=m; 
                          maxGroup = arr1[i];
                        }
                }
                m=0;
        }
        setBoothGroup(maxGroup?maxGroup:null)
        setBoothCuratedGroup(false);
        setPremiumCheck([])
        setDiscountCheck([])
        setPriceCheck([])
      }
      else{        
        setBoothGroup(null)
        setBoothCuratedGroup(null)
        setPremiumCheck([])
        setDiscountCheck([])
        setPriceCheck([])
      }

      setActiveObject(activeObject)
    }
  }  , [open])

  // Update area when width/height change for rectangular booths
  useEffect(() => {
    // Verify object is NOT a custom booth to prevent overwriting polygon area with W*H calculation
    if (activeObject && activeObject.class1 !== 'custom-booth' && checkifrectbooth(activeObject) && boothWidth && boothHeight && mainCanvas) {
      const area = boothWidth * boothHeight;
      const unitLabel = mainCanvas.mapUnit === 'feet' ? 'sqft' : 'sqm';
      setBoothArea(`${area.toFixed(2)} ${unitLabel}`);
    }
  }, [boothWidth, boothHeight]);
  
  const onChangeName = (e)=>{
    setBoothName(e.target.value)
  }
  
  return (
    
    <Dialog
      PaperComponent={PaperComponent}
      PaperProps={{drag_id:'setbooth-dialog-title'}}
      aria-labelledby="setbooth-dialog-title"
      fullWidth={true}
      maxWidth={"md"} 
      open={open}
    >
      <DialogTitle id='setbooth-dialog-title'>Booth Setup</DialogTitle>
      <DialogContent>
        <Box>
          <Grid container spacing={2} style={{marginTop:15}}>
            <Grid item xs={6}>
              <FormControl variant="outlined"
                size="small" fullWidth style={{marginTop:'7px'}}>
                <InputLabel shrink={true}>Group</InputLabel>
                <Select
                  input={<OutlinedInput notched label="Group" />}
                  fullWidth
                  size="small"
                  value={boothGroup?boothGroup:''}
                  onChange={(e)=>{setBoothGroup( e.target.value)}}
                  displayEmpty
                >
                  <MenuItem  value="">&nbsp;</MenuItem>
                  {
                    groupOptions.map((row, index)=>{
                      return(
                        <MenuItem key={index} value={row.KEY_ID}>{row.TITLE}</MenuItem>
                      )
                    })
                  }
                </Select>
              </FormControl>              
            </Grid>
            <Grid item xs={6}>
              {activeObject && activeObject.type !='activeSelection' &&
              <TextField
                name="boothName"
                margin="dense"
                label="Booth Name"
                type="name"
                fullWidth
                variant="outlined"
                size="small"
                value={boothName}
                onChange={onChangeName}
                disabled = {activeObject?.sold}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              }
            </Grid>
            {activeObject && activeObject.type !='activeSelection' &&
            <>
            {checkifrectbooth(activeObject) && 
            <Grid item xs={6}>
              <TextField
                name="boothWidth"
                margin="dense"
                label="Width"
                type="number"
                fullWidth
                variant="outlined"
                size="small"
                value={boothWidth}
                onChange={(e)=>{setBoothWidth(e.target.value)}}
                // disabled = {activeObject?.sold}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            }
            {checkifrectbooth(activeObject) && 
            <Grid item xs={6}>
              <TextField
                name="boothHeight"
                margin="dense"
                label="Height"
                type="number"
                fullWidth
                variant="outlined"
                size="small"
                value={boothHeight}
                onChange={(e)=>{setBoothHeight(e.target.value)}}
                // disabled = {activeObject?.sold}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            }
            {/* Shape field - always visible for single booth */}
            <Grid item xs={6}>
              <TextField
                name="boothShape"
                margin="dense"
                label="Shape"
                type="text"
                fullWidth
                variant="outlined"
                size="small"
                value={boothShape}
                InputProps={{
                  readOnly: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  '& .MuiInputBase-input': {
                    backgroundColor: '#f5f5f5',
                    cursor: 'default'
                  }
                }}
              />
            </Grid>
            {/* Size field - always visible for single booth */}
            <Grid item xs={6}>
              <TextField
                name="boothSize"
                margin="dense"
                label="Size"
                type="text"
                fullWidth
                variant="outlined"
                size="small"
                value={boothArea}
                InputProps={{
                  readOnly: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  '& .MuiInputBase-input': {
                    backgroundColor: '#f5f5f5',
                    cursor: 'default'
                  }
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="X"
                margin="dense"
                label="X"
                type="number"
                fullWidth
                variant="outlined"
                size="small"
                value={boothLeft}
                onChange={(e)=>{setBoothLeft(e.target.value)}}
                disabled = {activeObject?.sold}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="Y"
                margin="dense"
                label="Y"
                type="number"
                fullWidth
                variant="outlined"
                size="small"
                value={boothTop}
                onChange={(e)=>{setBoothTop(e.target.value)}}
                disabled = {activeObject?.sold}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            </>
            }
            <Grid item xs={6}>
              <TextField
                name="angle"
                margin="dense"
                label="Angle (degree) "
                type="name"
                fullWidth
                variant="outlined"
                size="small"
                value={boothAngle}
                onChange={(e)=>{setBoothAngle(e.target.value)}}
                disabled = {activeObject?.sold}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            
            <Grid item xs={6}>
              <FormControl variant="outlined"
                size="small" fullWidth style={{marginTop:'7px'}}>
                <InputLabel shrink={true}>Label Position</InputLabel>
                <Select
                  input={<OutlinedInput notched label="Label Position" />}
                  fullWidth
                  size="small"
                  value={labelPosition?labelPosition:''}
                  onChange={(e)=>{setLabelPosition( e.target.value); console.log(e.target.value)}}
                >
                  <MenuItem value='bottom-left'>Bottom Left</MenuItem>
                  <MenuItem value='bottom-right'>Bottom Right</MenuItem>
                  <MenuItem value='center'>Bottom Center</MenuItem>
                  <MenuItem value='top-left'>Top Left</MenuItem>
                  <MenuItem value='top-right'>Top Right</MenuItem>
                  <MenuItem value='top-center'>Top Center</MenuItem>
                </Select>
              </FormControl>              
            </Grid>
            <Grid item xs={4}>
              <TextField
                name="invite_code"
                margin="dense"
                label="Invite Code"
                type="name"
                fullWidth
                variant="outlined"
                size="small"
                value={inviteCode}
                onChange={(e)=>{setInviteCode(e.target.value)}}
                // onInput = {(e) =>{
                //   e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,15)
                // }}
                inputProps={{ maxLength: 15 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="outlined"
                size="small" fullWidth style={{marginTop:'7px'}}>
                <InputLabel shrink={true}>Booth Type</InputLabel>
                <Select
                  input={<OutlinedInput notched label="Booth Type" />}
                  fullWidth
                  size="small"
                  value={boothType?boothType:''}
                  onChange={(e)=>{setBoothType( e.target.value); console.log(e.target.value)}}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value='Island'>Island</MenuItem>
                  <MenuItem value='End cap'>End cap</MenuItem>
                  <MenuItem value='Inline'>Inline</MenuItem>
                  <MenuItem value='Corner'>Corner</MenuItem>
                  <MenuItem value='Peninsula'>Peninsula</MenuItem>
                </Select>
              </FormControl>              
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="outlined"
                size="small" fullWidth style={{marginTop:'7px'}}>
                <InputLabel shrink={true}>Curated Group</InputLabel>
                <Select
                  input={<OutlinedInput notched label="Curated Group" />}
                  fullWidth
                  size="small"
                  value={boothCuratedGroup?boothCuratedGroup:''}
                  onChange={(e)=>{setBoothCuratedGroup( e.target.value); console.log(e.target.value)}}
                  displayEmpty
                >
                  <MenuItem  value="">&nbsp;</MenuItem>
                  {
                    curatedGroupOptions.map((row, index)=>{
                      return(
                        <MenuItem key={index} value={row.KEY_ID}>{row.TITLE}</MenuItem>
                      )
                    })
                  }
                </Select>
              </FormControl>              
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="Public Booth Notes"
                margin="dense"
                label="Public Booth Notes"
                type="name"
                fullWidth
                variant="outlined"
                size="small"
                value={publicNote}
                onChange={(e)=>{setPublicNote(e.target.value)}}
                InputLabelProps={{
                  shrink: true,
                }}
                multiline
                rows={3}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="Private Booth Notes"
                margin="dense"
                label="Private Booth Notes"
                type="name"
                fullWidth
                variant="outlined"
                size="small"
                value={privateNote}
                onChange={(e)=>{setPrivateNote(e.target.value)}}
                InputLabelProps={{
                  shrink: true,
                }}
                multiline
                rows={3}
              />
            </Grid>
            <Grid item xs={6}>
              <Box mt={2}>
                <FormControlLabel
                  value="start"
                  control={<Switch color="primary" checked={holdBooth} 
                  onChange={(event)=>{
                    setHoldBooth(event.target.checked)
                  }}/>}
                  label="Hold Booth"
                  labelPlacement="start"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSet}>Ok</Button>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
    
  );
}
const mapStateToProps = (state) => {
    return {
      main: state.main,
    };
  };
  
  const mapDispatchProps = (dispatch) => {
    return {   
        setMainLayers: layers=>dispatch(setMainLayers(layers)), 
        setLoading:  data=>dispatch(setLoading(data)),
        setBoothHistory: data=>dispatch(setBoothHistory(data)),
        setSnackMsg: data=>dispatch(setSnackMsg(data)),
      setOpenSnack: data=>dispatch(setOpenSnack(data)),
      addLog:  data=>dispatch(addLog(data)),
    };
  };
  
export default connect(mapStateToProps, mapDispatchProps)(SetBoothModal);